import React from 'react'

import { func, string } from 'prop-types'

import highlightTranslation from 'Pods/Shared/Utils/highlightTranslation'

import formatPrice from 'Utils/formatPrice'

import { PLAN_CHANGE_KIND, PLAN_TYPE } from '../../../constants'
import { availablePlansShape, planChangeTargetShape } from '../../../propTypes'

const KEY = 'subscription_management.plan_change'
const EMPHASIS_CLASS = 'cgt-body-md-semibold plan-change-modal__emphasis'

function ScheduleStep({
  selection, tier, billingTerm, availablePlans, effectiveDate, translate,
}) {
  const tierName = (planTier) => translate(`${KEY}.tiers.${planTier}`)
  const planLabel = (planTier, term) => translate(`${KEY}.plan_label`, {
    tier: tierName(planTier), term: translate(`${KEY}.terms.${term}`),
  })
  const targetPlan = availablePlans[selection.tier]
  const isTargetAnnual = selection.billingTerm === PLAN_TYPE.ANNUAL
  const targetPrice = translate(`subscription_management.active.price_per_${isTargetAnnual ? 'year' : 'month'}`, {
    price: formatPrice(isTargetAnnual ? targetPlan.annualPrice : targetPlan.monthlyPrice),
  })

  return (
    <div className="plan-change-modal__body">
      <p className="cgt-body-base plan-change-modal__change-line">
        {highlightTranslation(translate, `${KEY}.schedule.change_line`, {
          to: planLabel(selection.tier, selection.billingTerm),
        }, 'cgt-body-base-semibold plan-change-modal__change-target', { from: planLabel(tier, billingTerm) })}
      </p>
      <div className="plan-change-modal__notice">
        {selection.kind === PLAN_CHANGE_KIND.DOWNGRADE ? (
          <>
            <p className="cgt-body-md plan-change-modal__notice-text">
              {highlightTranslation(
                translate,
                `${KEY}.schedule.${billingTerm === PLAN_TYPE.ANNUAL ? 'downgrade_notice_annual' : 'downgrade_notice'}`,
                {
                  plan: isTargetAnnual
                    ? tierName(selection.tier)
                    : translate(`${KEY}.schedule.plan_monthly`, { plan: tierName(selection.tier) }),
                  date: effectiveDate,
                },
                EMPHASIS_CLASS,
                { currentPlan: tierName(tier) },
              )}
            </p>
            <p className="cgt-body-base plan-change-modal__notice-text">
              {translate(`${KEY}.schedule.downgrade_details`, {
                date: effectiveDate,
                plan: tierName(selection.tier),
                downloads: targetPlan.downloadsPerMonth,
                generations: targetPlan.generationsPerMonth,
                price: targetPrice,
              })}
              {' '}
              <span className="plan-change-modal__notice-muted">{translate(`${KEY}.schedule.licensed`)}</span>
            </p>
          </>
        ) : (
          <p className="cgt-body-md plan-change-modal__notice-text">
            {highlightTranslation(translate, `${KEY}.schedule.to_monthly_notice`, {
              monthly: translate(`${KEY}.terms.monthly`),
              date: effectiveDate,
              price: targetPrice,
            }, EMPHASIS_CLASS)}
          </p>
        )}
      </div>
    </div>
  )
}

ScheduleStep.propTypes = {
  selection: planChangeTargetShape.isRequired,
  tier: string.isRequired,
  billingTerm: string.isRequired,
  availablePlans: availablePlansShape.isRequired,
  effectiveDate: string.isRequired,
  translate: func.isRequired,
}

export default ScheduleStep
